import React from 'react';
import useSWR from 'swr';
import { Flex, Box } from 'rebass';
import { useParams } from 'react-router-dom';

import { getSWR } from 'utils/api';
import { publicFamilyTreeKey } from '../api';
import { parsePublicFamilyTree } from '../helpers';
import QrFamilyTree from '../components/QrFamilyTree';

// Public, QR-linked Talking Family Tree page (see TFT-QrCode.png "Public Link").
// Route: /family_tree/:slug — fetches GET /v3/public/talking_family_trees/:slug.
// Rendered inside <Auth>; AuthMember creates a guest account for public routes
// (checkIfPublicRoute matches `/family_tree/`), so no chrome is shown here.
const PublicFamilyTree = () => {
  const { slug } = useParams();
  const { data, error } = useSWR(publicFamilyTreeKey(slug), getSWR, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const loading = !data && !error;
  const { members } = parsePublicFamilyTree(data);

  return (
    <Flex
      css="min-height: 100vh;"
      justifyContent="center"
      alignItems="flex-start"

      >
      <Flex
        width="100%"
        justifyContent="center"
        sx={{
          overflow: 'hidden',
        }}
      >
        <QrFamilyTree members={members} loading={loading} error={error} />
      </Flex>
    </Flex>
  );
};

export default PublicFamilyTree;
